module.exports = __webpack_public_path__ + "static/media/wDark_overcast.cf4ee1f3.svg";